var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.814,
    height: 25.291,
    viewBox: "0 0 20.814 25.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_reports",
    transform: "translate(-104.2 -435.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    transform: "translate(107.515 439)",
    fill: "#fff",
    stroke: "#0000b5",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 22.091,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 16,
    height: 20.591,
    rx: 1.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(112.225 443.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M1371.242,444.482l2.05-2.52.136.316.949,2.2,1.809-1.288",
    transform: "translate(-1368.397 -440.982)",
    fill: "none",
    stroke: "#0000b5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 7,
    fill: "none",
    stroke: "#0000b5",
    strokeLinecap: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 7.875,
    transform: "translate(0 7)",
    fill: "none",
    stroke: "#0000b5",
    strokeLinecap: "round",
    strokeWidth: 1.25
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 8,
    transform: "translate(112.015 454.415)",
    fill: "none",
    stroke: "#0000b5",
    strokeLinecap: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 8,
    transform: "translate(112.015 456.415)",
    fill: "none",
    stroke: "#0000b5",
    strokeLinecap: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M187.065,211.117h-1.394a.66.66,0,0,1-.624-.687v-17.97a.66.66,0,0,1,.624-.687h13.486a.66.66,0,0,1,.624.687v1.324a.627.627,0,1,0,1.248,0v-1.324a1.974,1.974,0,0,0-1.871-2.061H185.671a1.974,1.974,0,0,0-1.871,2.061v17.97a1.974,1.974,0,0,0,1.871,2.061h1.394a.69.69,0,0,0,0-1.374Z",
    transform: "translate(-79.4 245.6)",
    fill: "#0000b5",
    stroke: "#0000b5",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReports);
export default __webpack_public_path__ + "static/media/icon_reports.81a0ccf463ef8ecf5a5aca43efb05124.svg";
export { ForwardRef as ReactComponent };